import { defineStore } from 'pinia';
import { saveInLocalStorage, getFromLocalStorage } from '@/utils/local-storage';


const initialState = {
    myCompanies: {
        fetched: false,
        data: getFromLocalStorage('myCompanies', []),
    },

    fetched: false,
    unreadMessagesCount: getFromLocalStorage('unreadMessagesCount', 0)
}

export const useStateStore = defineStore('stateStore', {
    state: () => initialState,

    actions: {
        setMyCompanies(value, fetched = true) {
            this.myCompanies.data = value;
            this.myCompanies.fetched = fetched;
            saveInLocalStorage('myCompanies', value);
        },

        setFetched(value) {
            this.fetched = value;
        },

        setUnreadMessagesCount(count) {
            this.unreadMessagesCount = count;
            saveInLocalStorage('unreadMessagesCount', count);
        },

        incrementUnreadMessagesCount() {
            this.unreadMessagesCount = (this.unreadMessagesCount || 0) + 1;
            saveInLocalStorage('unreadMessagesCount', this.unreadMessagesCount);
        },

        resetUnreadMessagesCount() {
            this.unreadMessagesCount = 0;
            saveInLocalStorage('unreadMessagesCount', 0);
        }

    }
});